<template>
    <div class="logo-box">
        <!-- 自定义 Logo -->
        <template v-if="platformIcon && position != 'app' && !isDefaultLogo">
            <img
                v-if="platformIcon && !isDefaultLogo"
                :class="customLogo"
                :src="platformIcon"
            >
            <span class="custom-logo-main-title" :style="{color:platformTitleColor}">{{ $t(platformTitle || 'platformTitle') }}</span>
        </template>
        <!--gztv Logo-->
        <img
            v-else-if="profile == 'gztv' && !isDefaultLogo"
            :class="gztvLogo"
            :src="gztvLogoSrc"
        >
        <!--dayoo Logo-->
        <div v-else-if="profile == 'dayoo' && !isDefaultLogo">
            <img
                :class="dayooLogo"
                :src="dayooLogoSrc"
            >
            <span v-if="position == 'main'" class="dayoo-text-main">{{platformTitle}}</span>
        </div>
        <!--sxzm Logo-->
        <img
            v-else-if="profile == 'sxzm' && !isDefaultLogo"
            :class="sxzmLogo"
            :src="sxzmLogoSrc"
        >
        <!--dayoo Logo-->
        <div v-else-if="profile == 'dgrb' && !isDefaultLogo">
            <img
                class="dgrb-main-logo"
                :src="dgrbLogoSrc"
            >
            <span v-if="position == 'main'" class="dgrb-text-main">{{ $t(platformTitle || 'platformTitle') }}</span>
        </div>
        <div v-else>
            <!--主界面融媒体Logo-->
            <div v-if="position == 'main'">
<!--                 <img
                    v-if="platformIcon"
                    :src="platformIcon"
                    class="icon-main"
                > -->
                <Icon class="icon-main" type="md-cloudy"/>
                <span class="content-main">&nbsp;{{ $t(platformTitle || 'platformTitle') }}</span>
            </div>
            <!--登陆注册界面Logo-->
            <div v-else-if="position == 'login'">
<!--                 <img
                    v-if="platformIcon"
                    :src="platformIcon"
                    class="icon-login"
                > -->
                <Icon class="icon-login" type="md-cloudy" />
                <h1>PLATFORM</h1>
            </div>
            <!--app下载Logo-->
            <template v-else>
                <!-- <img
                    v-if="platformIcon"
                    :src="platformIcon"
                    class="icon-app"
                > -->
                <img src="@/assets/cameralive_icon.png" class="icon-app" />
            </template>
        </div>
    </div>
</template>

<script>
    /* eslint-disable vue/return-in-computed-property */
    import { mapState, mapActions } from "vuex";
    import api from "@/api/Api";
    export default {
        name: "logo",
        props: ['position'],
        data() {
            return {

            };
        },
        computed: {
            ...mapState({
                enableRegister: state => state.config.enableRegister,
                profile: state => state.config.profile,
                isDefaultLogo: state => state.config.defaultLogo,
                platformTitle: state => state.config.platformTitle,
                platformTitleColor: state => state.config.platformTitleColor,
                platformIcon: state => state.config.platformIcon,
            }),
            customLogo() {
                switch(this.position){
                    case 'main': return 'custom-logo-main';       //主界面顶部栏
                    case 'app': return 'custom-logo-app';         //app
                    case 'login': return 'custom-logo-login';     //登录界面
                }
            },
            gztvLogo(){
                switch(this.position){
                    case 'main': return 'gztv-logo-main';       //主界面顶部栏
                    case 'app': return 'gztv-logo-app';         //app
                    case 'login': return 'gztv-logo-login';     //登录界面
                }
            },
            gztvLogoSrc(){
                switch(this.position){
                    case 'main': return require('@/assets/gztv_logo.png');       //主界面顶部栏
                    case 'app': return require('@/assets/gztv_logo_app.png');    //app
                }
            },
            sznewsLogo(){
                return 'sznews-logo-login'
            },
            dayooLogo(){
                switch(this.position){
                    case 'main': return 'dayoo-logo-main';       //主界面顶部栏
                    case 'app': return 'dayoo-logo-app';         //app
                    case 'login': return 'dayoo-logo-login';     //登录界面
                }
            },
            dayooLogoSrc(){
                switch(this.position){
                    case 'main': return require('@/assets/dayoo_favicon.png');       //主界面顶部栏
                    case 'app': return require('@/assets/dayoo_favicon.png');    //app
                }
            },
            sxzmLogo(){
                switch(this.position){
                    case 'main': return 'sxzm-logo-main';       //主界面顶部栏
                    case 'app': return 'sxzm-logo-app';         //app
                }
            },
            sxzmLogoSrc(){
                switch(this.position){
                    case 'main': return require('@/assets/sxzm_logo.png');       //主界面顶部栏
                    case 'app': return require('@/assets/sxzm_favicon.svg');    //app
                }
            },
            dgrbLogoSrc() {
                return require("@/assets/dgrb_logo_mini.png");
            }
        },
        watch: {

        },
        methods: {

        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less" scoped>
    .logo-box{
        display: inline-block;
    }
    .icon-main{
        font-size:30px;
        color:white;
        vertical-align:middle;
    }
    img.icon-main {
        width: 28px;
        height: 28px;
    }
    .content-main{
        font-size:17px;
        color:white;
        vertical-align:middle;
        margin-right: 20px;
    }
    .icon-login {
        color: #5f97d8;
        font-size: 50px;
        font-weight: normal;
        margin-right: 20px;
        display: inline-block;
        vertical-align: middle;
    }
    img.icon-login {
        height: 36px;
        margin-right: 10px;
    }
    .icon-app {
        height:20px;
        margin-top:-1px
     }
    h1 {
        color: #5f97d8;
        font-size: 30px;
        font-weight: normal;
        margin: 0;
        display: inline-block;
        vertical-align: middle;
    }
    /* custom Logo */
    .custom-logo-main{
        // width: 102px;
        height: 28px;
        vertical-align:middle;
    }
    .custom-logo-main-title{
        font-size:17px;
        color:white;
        vertical-align:middle;
        margin-right: 20px;
        font-weight: 800;
        opacity: 0.95;
    }
    .custom-logo-app{
        width: 20px;
        height: 20px;
        vertical-align:middle;
    }
    .custom-logo-login{
        // width: 145px;
        height: 40px;
        vertical-align:middle;
    }
    /*gztv logo*/
    .gztv-logo-main{
        width: 102px;
        height: 36px;
        vertical-align:middle;
        margin-right: 20px
    }
    .gztv-logo-app{
        width: 20px;
        height: 20px;
        vertical-align:middle;
    }
    .gztv-logo-login{
        width: 145px;
        height: 45px;
        vertical-align:middle;
    }
    /*sznews Logo样式*/
    .sznews-logo-main{
        width: 102px;
        height: 36px;
        vertical-align:middle;
        margin-right: 20px
    }
    .sznews-logo-login{
        width: 180px;
        height: 56px;
        vertical-align:middle;
        margin-right: 20px
    }
    /*sxzm logo*/
    .sxzm-logo-main{
        width: 144px;
        height: 32px;
        vertical-align:middle;
        margin-right: 8px
    }
    .sxzm-logo-app{
        width: 16px;
        height: 16px;
        vertical-align:middle;
    }
    /*dayoo logo*/
    .dayoo-logo-main{
        width: 32px;
        height: 32px;
        vertical-align:middle;
        margin-right: 8px
    }
    .dayoo-text-main{
        font-size: 20px;
        font-weight: bold;
        color: white;
        vertical-align:middle;
    }
    .dayoo-logo-app{
        width: 16px;
        height: 16px;
        vertical-align:middle;
    }
    .dayoo-logo-login{
        width: 125px;
        height: 50.5px;
        vertical-align:middle;
    }
    /* ahdmy logo */
    .ahdmy-logo-main{
        width: 202px;
        height: 30px;
        vertical-align:middle;
        margin-right: 20px
    }
    .ahdmy-logo-app{
        width: 16px;
        height: 16px;
        vertical-align:middle;
    }
    .dgrb-main-logo {
        width: 20px;
        height: 20px;
        vertical-align:middle;
        margin-right: 5px;
    }
    .dgrb-text-main {
        font-size: 17px;
        color: white;
        vertical-align: middle;
        margin-right: 20px;
    }
</style>